import { Language } from "@constants/language";
import React from "react";
import { Modal, View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Theme } from "../enum/Theme";

interface Props {
  visible: boolean;
  value: Language | null;
  onSelect: (lang: Language | null) => void;
  onClose: () => void;
}

const languages = [
  { label: "Todos", value: null },
  { label: "Português", value: Language.PT },
  { label: "Inglês", value: Language.EN },
  { label: "Espanhol", value: Language.ES },
];

export const ModalFiltroLanguage: React.FC<Props> = ({ visible, value, onSelect, onClose }) => (
  <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
    <View style={styles.backdrop}>
      <View style={styles.modalBox}>
        <Text style={styles.title}>Filtrar por idioma</Text>
        {languages.map((lang) => (
          <TouchableOpacity
            key={String(lang.value)}
            style={[styles.item, value === lang.value && styles.selected]}
            onPress={() => {
              onSelect(lang.value as Language | null);
              onClose();
            }}
          >
            <Text style={value === lang.value ? styles.selectedText : styles.text}>
              {lang.label}
            </Text>
          </TouchableOpacity>
        ))}
        <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
          <Text style={styles.closeBtnText}>Fechar</Text>
        </TouchableOpacity>
      </View>
    </View>
  </Modal>
);

const styles = StyleSheet.create({
  backdrop: {
    flex: 1, backgroundColor: "rgba(0,0,0,0.30)", justifyContent: "center", alignItems: "center"
  },
  modalBox: {
    width: 280, backgroundColor: "#fff", borderRadius: 10, padding: 22, elevation: 8
  },
  title: { fontSize: 18, fontWeight: "bold", marginBottom: 20, textAlign: "center" },
  item: { paddingVertical: 12, borderRadius: 5, marginBottom: 4, alignItems: "center" },
  selected: { backgroundColor: Theme.foreground },
  text: { color: "#222" },
  selectedText: { color: "#fff", fontWeight: "bold" },
  closeBtn: { padding: 10, borderRadius: 10, alignItems: "center", backgroundColor: 'gray' },
  closeBtnText: { color:  '#fff', fontWeight: "bold" },
});
